'use strict';

goog.provide("Ntry.MazeEngineView");

Ntry.MazeEngineView = function() {
    this._view = Ntry.interfaceManager.getDom('ntryEngine');

    Ntry.addEventListener("run", this, this.viewModeRun);
    Ntry.addEventListener("stop", this, this.viewModeStop);
    Ntry.addEventListener("replay", this, this.viewModeReplay);

    this.createDom();
};

(function(p){
    p.createDom = function () {
        var parent = this._view;
        this._engineButton = Ntry.createElement('button', parent, 'ntryEngineButton', 'stopped');
        this._engineButton.innerHTML = Lang.Workspace.run;
        this._engineButton.bindOnClick(function(e){
            e.preventDefault();
            this.blur();
            Ntry.dispatchEvent('engineButtonClicked');
        });
    };

    p.viewModeRun = function () {
        var button = this.getPureButton();
        this._engineButton.innerHTML = Lang.Menus.engine_running;
        button.addClass('running');
        if (window.cpartyuserkey) {
            var script = Blockly.Xml.workspaceToDom(Blockly.mainWorkspace)
            var userScript = Blockly.Xml.domToText(script);
            var activity = new Entry.Activity('run', [[
                "script", userScript
            ]]);
            Entry.activityReporter.add(activity);
            Ntry.dispatchEvent('saveLogs');
        }
    };

    p.viewModeStop = function () {
        var button = this.getPureButton();
        this._engineButton.innerHTML = Lang.Workspace.run;
        button.addClass('stopped');
    };

    p.viewModeReplay = function () {
        var button = this.getPureButton();
        this._engineButton.innerHTML = Lang.Menus.engine_replay;
        button.addClass('end');
    };

    p.getPureButton = function() {
        this._engineButton.removeClasses();
        return this._engineButton;
    }

})(Ntry.MazeEngineView.prototype);
